import React from 'react';
import { makeClassName } from '@siteless/util';

const LaurelLeftIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('LaurelLeftIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M19.14,22.6c-0.32,0-0.65-0.01-0.97-0.04c-5.71-0.53-9.92-5.6-9.39-11.3C9.01,8.72,10.16,6.37,12,4.64
	c0.2-0.19,0.52-0.18,0.71,0.02c0.19,0.2,0.18,0.52-0.02,0.71c-1.67,1.57-2.71,3.69-2.92,5.98c-0.48,5.16,3.33,9.74,8.49,10.22
	c0.5,0.05,1,0.05,1.49,0.02c0.27-0.01,0.51,0.19,0.53,0.47c0.02,0.28-0.19,0.51-0.47,0.53C19.59,22.59,19.36,22.6,19.14,22.6z"
    />
    <path
      d="M10.39,7.6c-0.12,0-0.23-0.04-0.32-0.12C10.03,7.45,9.06,6.62,8.82,5.4C8.58,4.17,9.17,3.04,9.19,3
	c0.07-0.13,0.2-0.23,0.35-0.26c0.14-0.03,0.3,0.01,0.42,0.11C10,2.88,10.96,3.7,11.2,4.93c0,0,0,0,0,0c0.24,1.23-0.35,2.35-0.37,2.4
	c-0.07,0.13-0.2,0.23-0.35,0.26C10.46,7.6,10.42,7.6,10.39,7.6z M9.83,4.21c-0.06,0.29-0.09,0.64-0.02,1
	c0.07,0.35,0.23,0.67,0.4,0.91c0.06-0.29,0.09-0.64,0.02-1C10.15,4.77,9.99,4.46,9.83,4.21z"
    />
    <path
      d="M9.07,12.59c-0.03,0-0.07,0-0.1-0.01c-0.05-0.01-1.29-0.27-2.09-1.24c-0.8-0.97-0.82-2.24-0.82-2.29
	c0-0.15,0.07-0.29,0.18-0.39c0.12-0.1,0.27-0.14,0.42-0.1C6.71,8.57,7.95,8.83,8.75,9.8s0.82,2.23,0.82,2.29
	c0,0.15-0.07,0.29-0.18,0.39C9.29,12.55,9.18,12.59,9.07,12.59z M7.19,9.82c0.09,0.29,0.23,0.61,0.45,0.89
	c0.23,0.28,0.52,0.48,0.78,0.61c-0.09-0.29-0.23-0.61-0.45-0.89C7.75,10.16,7.46,9.96,7.19,9.82z"
    />
    <path
      d="M9.36,17.31c-0.43,0-0.96-0.06-1.47-0.3c-1.14-0.52-1.72-1.65-1.74-1.69c-0.07-0.14-0.07-0.29-0.01-0.43
	c0.06-0.14,0.18-0.24,0.33-0.28c0.05-0.01,1.28-0.33,2.42,0.19c1.14,0.52,1.72,1.65,1.74,1.69c0.07,0.13,0.07,0.29,0.01,0.43
	c-0.06,0.14-0.18,0.24-0.33,0.28C10.28,17.21,9.9,17.31,9.36,17.31z M7.5,15.51c0.2,0.22,0.47,0.45,0.8,0.6
	c0.33,0.15,0.68,0.2,0.97,0.21c-0.2-0.22-0.47-0.45-0.8-0.6S7.8,15.51,7.5,15.51z"
    />
    <path
      d="M14.73,21.32c-0.13,0-0.26-0.05-0.35-0.14c-0.04-0.04-0.94-0.94-1.08-2.18c-0.14-1.24,0.53-2.32,0.56-2.36
	c0.08-0.13,0.22-0.21,0.37-0.23c0.16-0.02,0.3,0.03,0.41,0.14c0.04,0.04,0.94,0.94,1.08,2.18l0,0c0.14,1.24-0.53,2.32-0.56,2.36
	c-0.08,0.13-0.22,0.21-0.37,0.23C14.77,21.32,14.75,21.32,14.73,21.32z M14.4,17.9c-0.08,0.29-0.14,0.63-0.1,0.99
	c0.04,0.36,0.17,0.68,0.32,0.94c0.08-0.29,0.14-0.63,0.1-0.99l0,0C14.68,18.48,14.55,18.16,14.4,17.9z"
    />
    <path
      d="M11.39,18.34c-0.05,0-0.11-0.01-0.16-0.02c-0.14-0.05-0.26-0.16-0.31-0.3c-0.02-0.05-0.46-1.24-0.07-2.43
	c0.39-1.19,1.45-1.89,1.5-1.91c0.13-0.08,0.29-0.1,0.43-0.06c0.14,0.05,0.26,0.16,0.31,0.3c0.02,0.05,0.46,1.24,0.07,2.43
	c0,0,0,0,0,0c-0.39,1.19-1.45,1.89-1.5,1.91C11.58,18.31,11.49,18.34,11.39,18.34z M12.31,15.04c-0.2,0.23-0.39,0.52-0.51,0.86
	c-0.11,0.34-0.12,0.69-0.1,0.99c0.2-0.23,0.39-0.52,0.51-0.86C12.32,15.69,12.33,15.34,12.31,15.04z M12.68,16.19L12.68,16.19
	L12.68,16.19z"
    />
    <path
      d="M11.8,9.62c-0.97,0-1.75-0.41-1.79-0.43c-0.13-0.07-0.23-0.2-0.26-0.35c-0.03-0.15,0.01-0.3,0.11-0.42
	c0.04-0.04,0.86-1.01,2.08-1.25c0,0,0,0,0,0c1.22-0.24,2.35,0.34,2.4,0.37c0.13,0.07,0.23,0.2,0.26,0.35
	c0.03,0.15-0.01,0.3-0.11,0.42c-0.04,0.04-0.86,1.01-2.08,1.25C12.21,9.6,12,9.62,11.8,9.62z M11.23,8.55
	c0.29,0.06,0.64,0.09,1,0.02c0.35-0.07,0.67-0.23,0.91-0.4c-0.29-0.06-0.64-0.09-1-0.02C11.79,8.23,11.48,8.39,11.23,8.55z"
    />
    <path
      d="M9.62,13.85c-0.27,0-0.49-0.21-0.5-0.48c-0.01-0.28,0.2-0.51,0.48-0.52c0.01,0,0.98-0.05,1.65-0.63
	c0.27-0.24,0.46-0.53,0.59-0.8c-0.28,0.09-0.6,0.24-0.87,0.48c-0.21,0.18-0.53,0.16-0.71-0.05c-0.18-0.21-0.16-0.52,0.05-0.71
	c0.94-0.82,2.21-0.88,2.26-0.88c0.18,0,0.3,0.06,0.4,0.17c0.1,0.11,0.14,0.27,0.12,0.42c-0.01,0.05-0.24,1.3-1.18,2.12
	c-0.94,0.82-2.21,0.88-2.27,0.88C9.63,13.85,9.62,13.85,9.62,13.85z"
    />
    <path
      d="M11.11,22.04c-1.09,0-1.97-0.55-2.01-0.58c-0.13-0.08-0.21-0.21-0.23-0.37c-0.02-0.15,0.04-0.3,0.14-0.41
	c0.04-0.04,0.93-0.94,2.18-1.08l0,0c1.25-0.15,2.32,0.53,2.36,0.56c0.13,0.08,0.21,0.21,0.23,0.37c0.02,0.15-0.04,0.3-0.14,0.41
	c-0.04,0.04-0.93,0.94-2.18,1.08C11.34,22.03,11.23,22.04,11.11,22.04z M10.36,20.93c0.29,0.08,0.63,0.14,0.99,0.1
	c0.36-0.04,0.68-0.18,0.94-0.32c-0.29-0.08-0.64-0.14-0.99-0.1C10.94,20.64,10.62,20.78,10.36,20.93z"
    />
    <path
      d="M12.36,5.51c-0.04,0-0.06,0-0.06,0c-0.15-0.01-0.29-0.08-0.38-0.2c-0.09-0.12-0.12-0.28-0.08-0.42
	c0.01-0.05,0.34-1.28,1.34-2.03c1-0.75,2.28-0.71,2.33-0.71c0.15,0.01,0.29,0.08,0.38,0.2c0.09,0.12,0.12,0.28,0.08,0.42
	c-0.01,0.05-0.34,1.28-1.34,2.03l0,0C13.73,5.47,12.64,5.51,12.36,5.51z M14.67,3.25c-0.29,0.07-0.62,0.2-0.91,0.41
	c-0.29,0.21-0.5,0.49-0.65,0.75c0.29-0.07,0.62-0.2,0.91-0.41l0,0C14.31,3.79,14.52,3.51,14.67,3.25z"
    />
  </svg>
);

export default LaurelLeftIcon;
